import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'relativeDate', standalone: true, pure: true })
export class RelativeDatePipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(iso: string): string {
    const date = new Date(iso);
    const diffDays = Math.floor((Date.now() - date.getTime()) / 86_400_000);
    if (diffDays === 0) return this.translate.instant('ai_chat.date_today');
    if (diffDays === 1) return this.translate.instant('ai_chat.date_yesterday');
    if (diffDays < 7) return this.translate.instant('ai_chat.date_days_ago', { count: diffDays });
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }
}
